/* import __COLOCATED_TEMPLATE__ from './card.hbs'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { group } from '@banking/ui/utils/activity';
const MAX_LENGTH = 6;
let Card = (_class = class Card extends Component {
  get groupedActivities() {
    return group(this.args.activities);
  }
  get hasActivities() {
    return this.args.activities.length > 0;
  }
  get limitedActivities() {
    const activities = this.groupedActivities.pending.slice(0, MAX_LENGTH);
    return [...activities, ...this.groupedActivities.completed.slice(0, MAX_LENGTH - activities.length)];
  }
  goToActivity(activity, event) {
    // Deselect the row that was just selected
    event.target.deselect();
    this.args.goToActivity(activity);
  }
}, _applyDecoratedDescriptor(_class.prototype, "goToActivity", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToActivity"), _class.prototype), _class);
export { Card as default };